/*
	Validator for student code characters
	Enforces the character rules under Student Code, Validation Rules: http://docs.digiexam.se:8080/display/PRODSPEC/Student+Role+Business+Rules
*/
angular.
module("dx.webapp.student").
directive("dxValidStudentCodeChars", function ValidStudentCodeChars(
	ValidStudentCodeCharsRegExp
) {
	"use strict";

	return {
		require: "ngModel",
		restrict: "A",
		link: function link(scope, el, attr, ctrl) {
			ctrl.$validators.dxValidStudentCodeChars = function validChars(modelValue, viewValue) {
				if (ctrl.$isEmpty(modelValue)) {
					return true;
				}

				return ValidStudentCodeCharsRegExp.test(viewValue);
			};
		},
	};
});
